module.exports = __webpack_public_path__ + "images/users/kaitori_focused_items/trading_cards/1_8f5c0fbfc5f0ef2a70e4e00483280265.jpg";